import { gql } from 'apollo-boost';

export const SAVE_GITHUB_REPOSITORY = gql`
    mutation($data: SaveGithubRepositoryInput!) {
        saveGithubRepository(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
